import { AppRoute } from '@launchpad';
import BaseModule from '@launchpad/logic/module/BaseModule';
import React from 'react';
import StipLogsNavigation from './StipLogsNavigation';

export const NAME = 'stip-logs';

export default class StipLogsModule extends BaseModule {
  getName() {
    return NAME;
  }

  getPermission() {
    return 'stip-logs.*';
  }

  getPolicy() {
    return 'Admin:StipLogs:View:*';
  }

  getNavigation() {
    return [
      {
        label: 'STIP',
        icon: 'star',
        path: null,
        permission: 'custom.stip-logs.*',
        policy: 'Admin:StipLogs:View:*',
        children: [
          {
            label: 'Dashboard',
            icon: 'list',
            path: '/stip-logs',
            permission: 'custom.stip-logs.dashboard.*',
            policy: 'Admin:StipLogs:View:*',
          },
          {
            label: 'List logs',
            icon: 'list',
            path: '/stip-logs/list',
            permission: 'custom.stip-logs.dashboard.*',
            policy: 'Admin:StipLogs:View:*',
          },
        ],
      },
    ];
  }

  getRoutes(currentUrl = '') {
    return [
      <AppRoute
        permission="custom.stip-logs.*"
        path="/stip-logs"
        component={StipLogsNavigation}
      />,
    ];
  }
}
